// 文案 —— **一份,两端共用。**
//
// ★ 为什么它必须共用
//   我抄了结构、抄了 CSS,却**自己编文案** —— 结果:
//     网页:「所有项目」「+ 新项目」「你正在使用 AutoLecture Pro」
//     桌面:「我的片子」「＋ 新建项目」「当前方案:云端 · 按量计费」
//   同一个产品,两套说法 —— 用户会觉得这是两个东西。
//   **文案也是「同一个东西两份定义」**,和 CSS、schema、配音是同一种病。
//
// 网页端有 i18n(zh/en 双语,695 条);桌面端目前只跑中文,但用**同一张表** ——
// 将来桌面要双语,一行都不用改。
import { TRANSLATIONS, type Lang } from './translations';

export { TRANSLATIONS };
export type { Lang };

/** 取一条文案。缺 key 时**返回 key 本身并告警** —— 让缺口暴露,而不是悄悄显示空白。
 *  同一个 key 只告警一次:心跳行每秒重渲,一个缺 key 能把日志刷出几百行(真机 2026-07-19),
 *  刷屏反而把别的错淹掉 —— 「暴露缺口」一行就够。 */
const warned = new Set<string>();
export function t(key: string, lang: Lang = 'zh'): string {
  const row = TRANSLATIONS[key];
  if (!row) {
    if (!warned.has(key)) { warned.add(key); console.warn(`[i18n] 缺 key: ${key}`); }
    return key;
  }
  return row[lang] ?? row.zh ?? key;
}

/** 给组件用的极简 hook(桌面端固定中文;网页端有自己的 useT,走同一张表)。 */
export const useT = (lang: Lang = 'zh') => (key: string) => t(key, lang);
